import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [open, setOpen] = useState(false);        // दाखले
  const [teamOpen, setTeamOpen] = useState(false); // पदाधिकारी

  // Click outside dropdown bandh
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-wrapper')) {
        setOpen(false);
        setTeamOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <>
      {/* TOP BAR - Original size */}
      <div className="top-bar">
        <div className="top-content">
          <span>ग्रामपंचायत  ठोंबरा | पंचायत समिती उमरेड, जि. नागपूर</span>
          <a href="tel:7038278133" className="service-no">
            📞 7038278133
          </a>
        </div>
      </div>

      {/* HEADER - Size bilkul same jaise pehla version tha */}
      <header className="header">
        <div className="header-inner">

          {/* LEFT - Logo + Title (attractive but size same) */}
          <div className="header-left">
            <img 
              src="/images/sj1.jpg" 
              alt="राष्ट्रीय चिन्ह" 
              className="emblem" 
            />
            <div className="title-box">
              <h1>ग्रामपंचायत  ठोंबरा</h1>
              <p>ISO 9001:2015 प्रमाणित</p>
            </div>
          </div>

          {/* RIGHT - 3 महापुरुष photos with LIGHT GLOW FRAME */}
          <div className="header-right personalities">
            <div className="photo-group">
              {[
                "/images/raje.jpg",
                "/images/Gadgemaharaj.jpg",
                "/images/tujdojimaharaj.jpeg",
              ].map((img, i) => (
                <img 
                  key={i} 
                  src={img} 
                  alt="महापुरुष" 
                  className="personality-img glow-frame"
                  style={{ animationDelay: `${i * 0.15}s` }} 
                />
              ))}
            </div>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>

        {/* NAV BAR - Size same, sirf 3D effect strong */}
        <nav className={`nav-bar ${menuOpen ? "open" : ""}`}>
          <Link to="/" className="nav-item">मुख्य पृष्ठ</Link>
          <Link to="/aboutus" className="nav-item">ग्रामपंचायत-बद्दल</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setTeamOpen(!teamOpen)} className="nav-item">
              पदाधिकारी व सदस्य ▾
            </span>
            {teamOpen && (
              <div className="dropdown">
                <Link to="/sachiv">ग्रामपंचायत अधिकारी</Link>
                <Link to="/sarpanch">सरपंच</Link>
                <Link to="/upsarpanch">उपसरपंच</Link>
                <Link to="/team">सदस्य / कर्मचारी</Link>
              </div>
            )}
          </div>

          <Link to="/meeting" className="nav-item">ग्रामसभा</Link>

          <div className="dropdown-wrapper">
            <span onClick={() => setOpen(!open)} className="nav-item">
              दाखले ▾
            </span>
            {open && (
              <div className="dropdown">
                <Link to="/janm-dakhala">जन्म दाखला</Link>
                <Link to="/mrut-dakhala">मृत्यू दाखला</Link>
                <Link to="/vivah-dakhala">विवाह दाखला</Link>
                <Link to="/namuna">नमुना ८</Link>
              </div>
            )}
          </div>

          <Link to="/devlopment" className="nav-item">विकास कामे</Link>
          <Link to="/gallery" className="nav-item">छायाचित्र</Link>
          <Link to="/contact" className="nav-item">संपर्क</Link>
        </nav>
      </header>

      <style>{`
        body { margin:0; font-family: "Noto Sans Devanagari", sans-serif; }

        /* Top Bar - same as before */
        .top-bar {
          background: #0b3d91;
          color: #fff;
          padding: 10px 0;
          font-weight: 600;
        }
        .top-content {
          max-width: 1300px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }
        .service-no {
          color: #ffcc00;
          text-decoration: none;
          font-weight: 700;
        }

        /* Header - SIZE EXACTLY SAME as your first code */
        .header {
          background: #ffffff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          border-bottom: 3px solid #138808;
        }
        .header-inner {
          max-width: 1300px;
          margin: auto;
          padding: 15px 20px;   /* same as original */
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        /* Logo - attractive floating but size same */
        .emblem {
          height: 70px;   /* same */
          transition: all 0.6s ease;
          animation: logoFloat 6s ease-in-out infinite;
        }
        .emblem:hover {
          transform: scale(1.08) rotate(8deg);
        }
        @keyframes logoFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        .title-box {
          background: #0b3d91;
          color: #fff;
          padding: 10px 25px;
          border-radius: 8px;
          border: 2px solid #138808;
        }
        .title-box h1 {
          margin: 0;
          font-size: 26px;   /* same */
          font-weight: 700;
        }
        .title-box p {
          margin: 4px 0 0;
          font-size: 13px;
        }

        /* 3 महापुरुष PHOTOS - LIGHT GLOW FRAME */
        .photo-group {
          display: flex;
          gap: 10px;
        }
        .personality-img {
          width: 58px;      /* same */
          height: 58px;
          border-radius: 50%;
          border: 2px solid #0b3d91;
          object-fit: cover;
          box-shadow: 
            0 0 12px rgba(255, 215, 0, 0.9),    /* golden light */
            0 0 22px rgba(19, 136, 8, 0.85),   /* green light */
            0 8px 20px rgba(0,0,0,0.25);
          transition: all 0.4s ease;
        }
        .personality-img:hover {
          transform: scale(1.15);
          box-shadow: 
            0 0 25px #ffd700,
            0 0 35px #138808,
            0 15px 30px rgba(0,0,0,0.3);
        }

        /* Hamburger - same */
        .hamburger {
          display: none;
          font-size: 30px;
          color: #0b3d91;
          cursor: pointer;
        }

        /* NAV BAR - size same, only STRONG 3D effect */
        .nav-bar {
          background: #f8f9fa;
          padding: 12px 0;   /* same */
          display: flex;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
          border-top: 1px solid #ddd;
        }
        .nav-item {
          text-decoration: none;
          color: #0b3d91;
          font-weight: 600;
          padding: 8px 16px;   /* same size */
          border-radius: 4px;
          transition: all 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: relative;
        }
        .nav-item:hover {
          background: linear-gradient(135deg, #0b3d91, #138808);
          color: #fff;
          transform: 
            perspective(800px) 
            rotateX(22deg) 
            rotateY(18deg) 
            translateY(-6px);
          box-shadow: 0 20px 35px rgba(11, 61, 145, 0.45);
          border-radius: 8px;
        }

        /* Dropdown - same */
        .dropdown-wrapper { position: relative; }
        .dropdown {
          position: absolute;
          top: 48px;
          background: #fff;
          border: 1px solid #ddd;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 999;
          min-width: 200px;
        }
        .dropdown a {
          display: block;
          padding: 10px 20px;
          color: #333;
          border-bottom: 1px solid #eee;
        }
        .dropdown a:hover {
          background: #f0f4ff;
          color: #0b3d91;
        }

        /* Mobile - same */
        @media (max-width: 768px) {
          .personalities { display: none; }
          .hamburger { display: block; }
          .nav-bar {
            display: none;
            flex-direction: column;
            padding: 20px;
            background: #fff;
          }
          .nav-bar.open { display: flex; }
          .title-box h1 { font-size: 20px; }
          .emblem { height: 55px; }
        }
      `}</style>
    </>
  );
};

export default Header;